module.exports = __webpack_public_path__ + "static/media/emojis2_14.e7c0e0aa.svg";